import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {PitFilterValue} from "./pit-filter-value";

@jsonObject
export class PitFilteringAttribute {
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  @jsonMember({name: "ident", constructor: String, emitDefaultValue: false, isRequired: false })
  private _ident: string;

  @jsonArrayMember(PitFilterValue, {name: "values", emitDefaultValue: false, isRequired: false })
  private _values: PitFilterValue[];

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get ident(): string {
    return this._ident;
  }

  set ident(value: string) {
    this._ident = value;
  }

  get values(): PitFilterValue[] {
    return this._values;
  }

  set values(value: PitFilterValue[]) {
    this._values = value;
  }
}
